// extracted by mini-css-extract-plugin
export var dividerLine = "_6c-0";
export var errorBackground = "_6c-1";